var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:['badge', 'text-white', _vm.getDueDateBadge(_vm.dueDate, _vm.status)],staticStyle:{"line-height":"1.2"}},[_vm._v(_vm._s(_vm._f("dateBr")(_vm.dueDate)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }